import React, { PureComponent } from "react";
import { Spin } from "antd";
import { connect } from "react-redux";
import { withActions, isBusy } from "actionware";
import { getTranslate } from "react-localize-redux";

import Application from "../application/application";
import { getRole, getLenderId } from "../../common/helpers";

import "./approval.less";
import ApprovalSetting from "../approvalSetting/setting";
import { fetchLenderPortfolioV2 } from "./summaryActions.js";
import { getApplication } from "../application/applicationApprovalActions";
import { isLenderPortfolioApiEnabled } from "../../common/config";

@connect(({ localize }) => ({
  translate: getTranslate(localize),
  loading: isLenderPortfolioApiEnabled()
    ? isBusy(fetchLenderPortfolioV2, getApplication)
    : isBusy(getApplication),
}))
@withActions({
  fetchLenderPortfolioV2,
  getApplication,
})
class Approval extends PureComponent {
  constructor() {
    super();
    this.state = {
      role: undefined,
      lender_id: undefined,
      showSettingsView: false,
    };
  }

  async componentWillMount() {
    const role = await getRole();
    const lenderId = await getLenderId();
    this.setState({ role, lenderId });
    this.resetViewToApprovalPage = this.resetViewToApprovalPage.bind(this);

    if (isLenderPortfolioApiEnabled()) {
      this.props.fetchLenderPortfolioV2({ lender_id: lenderId });
    }

    this.setState({ currentLenderId: lenderId });
    const params = {
      status: "pending",
      page: 1,
      size: 10,
      lender_id: lenderId === 0 ? "all" : lenderId,
      sort_field: "submission_date",
      sort_order: "desc",
    };
    this.props.getApplication(params);
  }

  resetViewToApprovalPage = () => {
    const { lenderId } = this.state;
    this.setState({ showSettingsView: false });
    if (isLenderPortfolioApiEnabled()) {
      this.props.fetchLenderPortfolioV2({ lender_id: lenderId });
    }
    const params = {
      status: "pending",
      page: 1,
      size: 10,
      lender_id: lenderId === 0 ? "all" : lenderId,
      sort_field: "submission_date",
      sort_order: "desc",
    };
    this.props.getApplication(params);
  };

  setViewToSettingsPage = () => {
    this.setState({ showSettingsView: true });
  };

  renderSettingPageView = () => {
    return (
      <>
        <ApprovalSetting
          resetViewToApprovalPage={this.resetViewToApprovalPage}
        />
      </>
    );
  };

  render() {
    const { role } = this.state;
    const { translate, loading } = this.props;
    if (this.state.showSettingsView) {
      return this.renderSettingPageView();
    } else {
      if (loading) {
        return <Spin tip={translate("generic.loadingData")} size="large" />;
      }
      return (
        <div className={`approval`}>
          <Application
            extra={false}
            role={role}
            setViewToSettingsPage={this.setViewToSettingsPage}
          />
        </div>
      );
    }
  }
}

export default Approval;
